import { Component, EventEmitter, OnInit, Output, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Alert_Interface, Empty_Alert_Interface } from 'src/app/Interface/Alert_Interface';
import { AlertService } from 'src/app/Service/Alert/Alert.service';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-AlertUserList',
  templateUrl: './AlertUserList.component.html',
  styleUrls: ['./AlertUserList.component.scss']
})
export class AlertUserListComponent implements OnInit {

  @Output() OnBack_Alert_Action = new EventEmitter<string>();
  page: number = 0;
  Procssing: boolean = false
  BaseUrl = environment.BaseUrl
  Filter_title:string=""
  Filter_username: string = ""
  Filter_dsc: string = ""

  constructor(
    private Nav_Service: NavService,
    private Alert_Service: AlertService,
    private Alertify_Service: AlertifyService,
    private modalService: BsModalService,
  ) { }

  DataList_Alert: Array<Alert_Interface> = []
  Data_Seleted_Alert: Alert_Interface = Empty_Alert_Interface()
  modalRef_Alert: any

  ngOnInit() {
    this.ReadData_Alert('','')
  }

  StartDate:string=""
  EndDate:string=""

  ReadData_Alert(StartSearchDate, EndSearchDate) {
    this.StartDate=StartSearchDate
    this.EndDate = EndSearchDate

    this.Procssing = true
    this.Alert_Service.GetInbox(StartSearchDate,EndSearchDate).subscribe(
      data => {
        this.DataList_Alert = data
        this.Procssing = false
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  View_Form_Switcher:String='List'


  OnSet_Back() {
    this.OnBack_Alert_Action.emit('Hidden');
  }

  on_Set_View(item: Alert_Interface,template: TemplateRef<any>)
  {
    this.modalRef_Alert = this.modalService.show(template);
    this.Data_Seleted_Alert=item
  }

  Change_Filter_title(){
    this.page=0
  }

}
